import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { RadMeter, RadMeterUnit } from '../rad-meters';
import { BaseComponent } from 'src/app/common/base/base.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { RadMetersService } from '../services/rad-meters.service';
import { RadMetersUnitsDetailsComponent } from './rad-meters-units-details/rad-meters-units-details.component';

@Component({
  selector: 'rad-meters-units',
  templateUrl: './rad-meters-units.component.html',
  styleUrls: ['./rad-meters-units.component.scss']
})
export class RadMetersUnitsComponent extends BaseComponent implements OnInit {
  public valueFilter = '';
  public dataSource: MatTableDataSource<RadMeterUnit> = new MatTableDataSource<RadMeterUnit>();
  public showInactive!: boolean;
  public loading = false;
  public radMetersUnitsList?: RadMeterUnit[];
  public displayedColumns: string[] = ['name', 'description', 'status', 'actions'];
  public createAvailable!: boolean;
  public selectedRowIndex = -1;
  public pending = false;

  constructor(
    protected override injector: Injector,
    private dialogRef: MatDialogRef<RadMetersUnitsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RadMeter,
    private _service: RadMetersService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.clear();
    this.loadMeterUnits();
    this.createAvailable = true;
  }

  clear() {
    this.showInactive = true;
    this.selectedRowIndex = 0;
    this.dataSource = new MatTableDataSource();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async loadMeterUnits(event?: any) {
    this.loading = true;
    this.valueFilter = '';
    await this._service.getRadMeterUnits().toPromise().then(result => {
      if (!(result?.length)) {
        result = [];
      }
      this.radMetersUnitsList = result;
      if (!this.showInactive) {
        this.dataSource = new MatTableDataSource<RadMeterUnit>(result.filter(x => x.status == 1));
      } else {
        this.dataSource = new MatTableDataSource<RadMeterUnit>(result);
      }
    }).finally(() => this.loading = false);
  }

  refreshMeterUnits(event?: any) {
    this.loadMeterUnits();
    this.selectedRowIndex = -1;
  }

  showMetersUnitsInactive() {
    this.loadMeterUnits();
  }

  sortData(sort: Sort) {
    const data = this.radMetersUnitsList;
    let sortedData: RadMeterUnit[];
    if (!sort.active || sort.direction === '') {
      sortedData = data ?? [];
      return;
    }
    sortedData = data?.sort((a, b) => {
      const isDesc = sort.direction === 'desc';
      switch (sort.active) {
        case 'name': return compare(a.name, b.name, isDesc);
        case 'description': return compare(a.description, b.description, isDesc);
        case 'status': return compare(a.status, b.status, isDesc);
        default: return 0;
      }
    }) ?? [];
    this.dataSource = new MatTableDataSource(sortedData);
  }

  highlight(row: any) {
    if (!this.pending) {
      this.selectedRowIndex = row.id;
    }
  }

  getPosition(row: any): number {
    const i = this.dataSource.data.findIndex(r => {
      return r.id == row.id;
    });
    return i;
  }

  getColor(radMeterUnit: RadMeterUnit): string {
    if (radMeterUnit.status == 0) {
      return '#D8D8D8';
    }
    else {
      return '#000000';
    }
  }

  createMeterUnit() {
    this.selectedRowIndex = 0;
    const MeterUnitNew: RadMeterUnit = {} as RadMeterUnit;
    MeterUnitNew.id = 0;
    MeterUnitNew.description = '';
    MeterUnitNew.code = '';
    MeterUnitNew.status = 1;
    MeterUnitNew.name = '';
    MeterUnitNew.type = 0;
    this.openDetailsMeterUnit(MeterUnitNew);
  }

  openDetailsMeterUnit(MeterUnitNew: RadMeterUnit) {
    const dataDialog = MeterUnitNew;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = dataDialog;
    dialogConfig.minWidth = '35vw';
    dialogConfig.maxHeight = '85%';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(RadMetersUnitsDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data != undefined) {
        this.loading = true;
        this.refreshMeterUnits(data);
        if (data == 'Create') {
          this.alert.success(this.getMessage('RAD_Meters_Catalog_Update_Unit_Succeed')?.description);
        }
        else if (data == 'Update') {
          this.alert.success(this.getMessage('RAD_Meters_Catalog_Update_Unit_Succeed').description);
        }
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  async deleteMeterUnit(element: RadMeterUnit) {
    const confirm = this.dialog.open(YesNoDialogComponent, {
      width: '400px',
      data: {
        message: this.getMessage('RAD_Meters_Catalog_Confirm_Delete_Unit')?.description,
        icon: 'stop'
      }
    });
    confirm.afterClosed().toPromise().then(async data => {
      if (data && element.id) {
        this.loading = true;
        await this._service.deleteRadMeterUnit(element.id).toPromise().then(() => {
          this.alert.success(this.getMessage('RAD_Meters_Catalog_Delete_Unit_Succeed')?.description);
        }).catch(() => {
          this.alert.message('genericError');
        });
      }
    }, error => {
    }).finally(() => {
      this.loading = false;
      this.refreshMeterUnits(true);
    });
  }

  EditMeterUnit(element: RadMeterUnit) {
    this.openDetailsMeterUnit(element);
  }
}
function compare(a?: number | string, b?: number | string, isAsc?: boolean) {
  if (a && b)
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  return 1;
}
